import React, { useRef, useEffect } from "react";
import { InputProps, regex, TextInput, useTranslate } from "react-admin";
import Inputmask from "inputmask";

interface Props extends InputProps {}

export const PhoneNumberInput = (props: Props) => {
  const translate = useTranslate();
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    var im = new Inputmask("(999) 999-9999");
    im.mask(ref.current);
  });

  return (
    <TextInput
      {...props}
      inputRef={ref}
      validate={regex(
        /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
        translate("resources.common.labels.mustBeValidPhoneNumber")
      )}
    />
  );
};
